import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Nav,
  ProgressBar,
  Row,
  Tab,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Layout from "../../Layout";
import TitleCommon from "../TitleCommon";
import { BarGauge, Chart, CircularGauge, Tooltip } from "devextreme-react";
import {
  ArgumentAxis,
  Font,
  Legend,
  Series,
  Title,
  ValueAxis,
} from "devextreme-react/cjs/chart";
import { Export, Label } from "devextreme-react/cjs/data-grid";
import {
  Range,
  RangeContainer,
  Scale,
} from "devextreme-react/cjs/circular-gauge";
import { LuMilestone } from "react-icons/lu";
import { FaBolt, FaWater } from "react-icons/fa";

const COLORS = {
  orange: "#e7701e",
  greyDark: "#3a3a3a",
  grey: "#58595b",
  greyLight: "#f5f5f5",
  blue: "#0070c0",
};

const HvBriefcase = () => {
  const [t, i18n] = useTranslation("briefcase");
  const [method, setMethod] = useState("Waterfall");

  const overview = {
    plannedCost: 233640717,
    actualCost: 233640717,
    projectsCount: 3,
    plannedDurationPct: 100,
    executedDurationPct: 100,
    criticalPathDeviation: 0,
  };

  const values = [100, 50.5];
  const format = {
    type: "fixedPoint",
    precision: 1,
  };
  function customizeText({ valueText }) {
    return `${valueText} %`;
  }

  const comparisonData = [
    { method: 'Waterfall', planned: 100, actual: 90 },
    { method: 'Agile',    planned: 80,  actual: 70 }
  ];
  return (
    <>
      <Layout>
        <TitleCommon
          title={{
            text: t("hvbriefcase_tittle"),
            icon: "chart-line",
          }}
          color="secondary"
          goBack={{
            text: t("briefcase_title_back"),
            icon: "arrow-left",
          }}
        />
        <Container
          fluid
          className="bg-light mt-2 py-4"
          style={{ maxWidth: "1400px" }}
        >
          <Card className="mb-3">
            <Card.Body>
              <Tab.Container
                defaultActiveKey="waterfall"
                onSelect={(k) => setMethod(k)}
              >
                <Nav variant="pills">
                  <Nav.Item>
                    <Nav.Link eventKey="waterfall">
                      <FaWater className="mr-1" /> Waterfall
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="agile">
                      <FaBolt className="mr-1" /> Agile
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Tab.Container>
            </Card.Body>
          </Card>
          {/* =========================
          SECCIÓN 1: CARDS
            ========================== */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-light">
              <h5 className="mb-0">
                <i className="fa fa-briefcase text-primary mr-2"></i>
                Portafolio
              </h5>
            </Card.Header>
            <CardBody>
              <Row>
                <Col md={3}>
                  <Card
                    style={{
                      minHeight: "120px",
                      borderLeftColor: "#db526a",
                      borderLeftWidth: "5px",
                    }}
                  >
                    <Card.Title className="h6 text-danger my-1 mx-2">
                      Nombre Portafolio
                    </Card.Title>
                    <CardBody className="px-2 py-1 h5">PortaFolio 1</CardBody>
                    <CardFooter className="px-2 py-1">
                      Última Actualización: 28/02/2023
                    </CardFooter>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card
                    style={{
                      minHeight: "120px",
                      borderLeftColor: "#db526a",
                      borderLeftWidth: "5px",
                    }}
                  >
                    <Card.Title className="h6 text-danger my-1 mx-2">
                      Cantidad de proyectos
                    </Card.Title>
                    <CardBody className="d-flex justify-content-start align-items-center px-2 py-1 h5">
                      <div>
                        <div>Agiles : 10</div>
                        <div>Tradicionales :20</div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card
                    style={{
                      minHeight: "120px",
                      borderLeftColor: "#db526a",
                      borderLeftWidth: "5px",
                    }}
                  >
                    <Card.Title className="h6 text-danger my-1 mx-2">
                      Fechas
                    </Card.Title>
                    <CardBody className=" d-flex justify-content-start align-items-cente px-2 py-1">
                      <div className="d-flex flex-column">
                        <div className="d-flex justify-content-between">
                          <span className="h5">Planeado : </span>
                          <span>01/01/2024 - 01/01/2025</span>
                        </div>
                        <div className="d-flex justify-content-between ">
                          <span className="h5">Real : </span>
                          <span>01/01/2024 - 01/01/2025</span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={2}>
                  <Card
                    style={{
                      minHeight: "120px",
                      borderLeftColor: "#db526a",
                      borderLeftWidth: "5px",
                    }}
                  >
                    <Card.Title className="h6 text-danger my-1 mx-2">
                      Fecha de corte
                    </Card.Title>
                    <CardBody className="d-flex justify-content-center align-items-center  px-2 py-1 h4">
                      01/01/2024
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {/* =========================
                SECCIÓN 2: COSTOS
            ========================== */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-light">
              <h5 className="mb-0">
                <i className="fa fa-dollar-sign text-primary mr-2"></i>
                Costos
              </h5>
            </Card.Header>
            <CardBody>
              <Row>
                <Col className="mb-3" md={6} lg={6}>
                  <Card className="mb-3">
                    <Card.Body className="p-3">
                      <Card.Title>Costo Planeado</Card.Title>
                      <span className="h2 mb-0 mt-2 d-block">
                        <i className="fa fa-wallet mr-2 text-primary"></i>$
                        {new Intl.NumberFormat().format(0)}
                      </span>
                    </Card.Body>
                  </Card>
                  <h5 className="text-muted mb-3">Resumen costos</h5>
                  <h6>
                    Costo Planeado ($
                    {new Intl.NumberFormat().format(0)}){" "}
                    <span className="float-right">100%</span>
                  </h6>
                  <ProgressBar
                    variant="info"
                    now={100}
                    style={{ height: "12px" }}
                  />
                  <br />
                  <h6>
                    Costo Real ($
                    {new Intl.NumberFormat().format(0)}){" "}
                    <span className="float-right">
                      {Math.round(((1 * 100) / 2 + Number.EPSILON) * 100) /
                        100 || 0}
                      %
                    </span>
                  </h6>
                  <ProgressBar
                    variant="success"
                    now={(1 * 100) / 2 || 0}
                    style={{ height: "12px" }}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Card>
                    <Card.Body>
                      <h6>Costos</h6>
                      <BarGauge
                        id="gauge"
                        startValue={0}
                        endValue={100}
                        defaultValues={values}
                        barSpacing={20}
                        palette={["#29b9d0", "#6ab41b"]}
                      >
                        <Label
                          indent={20}
                          format={format}
                          customizeText={customizeText}
                        />
                        <Export enabled={true} />
                        {/*   <Title text={"Series' Ratings"}>
                          <Font size={28} />
                        </Title> */}
                      </BarGauge>
                      {/*   <CircularGauge
                        value={overview.executedDurationPct}
                        startAngle={180}
                        endAngle={0}
                      >
                        <Scale
                          startValue={0}
                          endValue={100}
                          tickInterval={20}
                        />
                        <RangeContainer>
                          <Range
                            startValue={0}
                            endValue={overview.executedDurationPct}
                            color={COLORS.orange}
                          />
                        </RangeContainer>
                        <Label font={{ size: 14 }} />
                      </CircularGauge> */}
                      <p className="text-center mt-2">
                        <strong>50.5 %</strong> Real
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {/* =========================
                SECCIÓN 3: DURACION
            ========================== */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-light">
              <h5 className="mb-0">
                <i className="fa fa-clock text-primary mr-2"></i>
                Duración
              </h5>
            </Card.Header>
            <CardBody>
              <Row></Row>
            </CardBody>
          </Card>
          {/* =========================
                SECCIÓN 4: HITOS
            ========================== */}
          <Card className="shadow-sm mb-4">
            <Card.Header className="bg-light">
              <h5 className="mb-0">
                <LuMilestone className="text-primary mr-2" size={24} />
                HITOS
              </h5>
            </Card.Header>
            <CardBody>
              <Row></Row>
            </CardBody>
          </Card>
            {/* =========================
                SECCIÓN 5: KPI's
            ========================== */}

          <Card>
            <Card.Header></Card.Header>
            <CardBody>
              <Row>
                {/* Comparativo Planeado vs Real por Metodología */}
                <Col md={6} className="mb-3">
                  <Card>
                    <Card.Header>Comparativo Planeado vs Real</Card.Header>
                    <Card.Body>
                      <Chart data={comparisonData}>
                        <Series
                          type="stackedBar"
                          argumentField="method"
                          valueField="planned"
                          name="Planeado"
                          color={COLORS.blue}
                        />
                        <Series
                          type="stackedBar"
                          argumentField="method"
                          valueField="actual"
                          name="Real"
                          color={COLORS.orange}
                        />
                        <ArgumentAxis />
                        <ValueAxis />
                        <Legend
                          verticalAlignment="bottom"
                          horizontalAlignment="center"
                        />
                        <Tooltip enabled />
                      </Chart>
                    </Card.Body>
                  </Card>
                </Col>

                {/* KPIs específicos */}
                <Col md={6} className="mb-3">
                  <Card>
                    <Card.Header>KPI {method}</Card.Header>
                    <Card.Body>
                      {method === "Waterfall" ? (
                        <ul>
                          <li>SPI: 0.95</li>
                          <li>CPI: 1.02</li>
                          <li>% Hitos on-time: 80%</li>
                        </ul>
                      ) : (
                        <ul>
                          <li>Velocidad sprint: 30 pts</li>
                          <li>% Historias completadas: 90%</li>
                          <li>Lead time medio: 5 días</li>
                        </ul>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </Layout>
    </>
  );
};

export default HvBriefcase;
